
export function mergeSortArrays(arrays, key) {
  const merged = [];
  while (arrays.length > 0) {
    merged.push(arrays.sort((a, b) => (b[0][key] - a[0][key]))[0].shift());
    arrays = arrays.filter((arr) => (arr.length > 0));
  }
  return merged;
}

const _sortSpecs = (scores) => (
  mergeSortArrays(
    Object.keys(scores).map(key => (
      scores[key].detail && typeof scores[key].detail === "object" && Object.keys(scores[key].detail).length > 0
        ? _sortSpecs(scores[key].detail).map(spec => ({ ...spec, path: `${key}/${spec.path}` }))
        : [{ path: key, score: scores[key].score }]
    )),
    'score'
  )
);


export function sortSpecs4AllTools(tools) {
  return Object.keys(tools).map((tool) => {
    if (!tools[tool].detail) return { tool, score: tools[tool].score };

    const sortedSpecs = _sortSpecs(tools[tool].detail);
    return { tool, score: tools[tool].score, sortedSpecs };
  }).sort((toolA, toolB) => (toolB.score - toolA.score));
}

export const sortSpecsByWeight = (weights) => (
  mergeSortArrays(
    Object.keys(weights).map(key => (
      weights[key] && typeof weights[key] === "object"
        ? Object.keys(weights[key]).length > 0
          ? sortSpecsByWeight(weights[key]).map(spec => ({ ...spec, path: `${key}/${spec.path}` }))
          : [{ path: key, weight: 0 }]
        : [{ path: key, weight: weights[key] }]
    )),
    'weight'
  )
)